import { contactNames } from '@/clientOnlyUtils/clientUtils';

import { type SvrContactField } from '@poseidon/types/svr/svrContact.type';
import { type SvrOrgField } from '@poseidon/types/svr/svrOrg.type';

import { useDeleteContactImageMutation } from '@/hooks/trpc/useContactMutation';

import Avatar, { type AvatarProps } from './Avatar';

type ContactAvatarProps = Omit<AvatarProps, 'onError' | 'srcs' | 'alt'> & {
  contact: {
    id: string;
    primaryFields: {
      firstName?: SvrContactField;
      lastName?: SvrContactField;
      nameFull?: SvrContactField;
      pictureUrl?: SvrContactField;
    };
  };
  org?: {
    id: string;
    primaryFields: { pictureUrl?: SvrOrgField };
  };
};

export default function ContactAvatar({ contact, org, ...props }: ContactAvatarProps) {
  const pictureUrlObj = contact.primaryFields.pictureUrl;
  const orgPictureUrl = org?.primaryFields.pictureUrl;
  const deleteContactImageMutation = useDeleteContactImageMutation();
  // const clearbitUrl = org?.fields.pictureUrl?.find((f) => f.source == 'clearbit')?.data;

  const onError = (index: number) => {
    const source = pictureUrlObj?.source;
    if (index === 0 && source) {
      deleteContactImageMutation.mutate({
        contactId: contact.id,
        source,
      });
    }
  };

  return (
    <Avatar
      srcs={[!pictureUrlObj?.data.startsWith('http') ? undefined : pictureUrlObj?.data, orgPictureUrl?.data]}
      alt={contactNames(contact).join(' ')}
      onError={onError}
      coloredBackground
      {...props}
    />
  );
}
